'use strict';
Object.defineProperty(exports, "__esModule", { value: true });
exports.ManufacturingSlider = void 0;
const $ = require("jquery");
const swiper_1 = require("swiper");
const modules_1 = require("swiper/modules");
const gsap_1 = require("gsap");
const ScrollTrigger_1 = require("gsap/ScrollTrigger");
const ScrollToPlugin_1 = require("gsap/ScrollToPlugin");
gsap_1.gsap.registerPlugin(ScrollTrigger_1.ScrollTrigger, ScrollToPlugin_1.ScrollToPlugin);
class ManufacturingSlider {
    constructor() {
        const self = this;
        // -------------------------------------------------
        // デバイス判定
        // -------------------------------------------------
        const isMobile = window.matchMedia("(max-width: 767px)").matches;
        let isModalOpen = false; // モーダル開いてるかどうか（スライドの戻りで削除する処理を止めるためのフラグ）
        // -------------------------------------------------
        // Swiperの初期設定
        // -------------------------------------------------
        const target = document.querySelector('.bulletKnowSlider');
        if (!target)
            return;
        const swiperPagination = document.querySelector('.swiper-pagination');
        const swiperNextButton = document.querySelector('.swiper-button-next');
        const swiperPrevButton = document.querySelector('.swiper-button-prev');
        const swiper = new swiper_1.default(target, {
            modules: [modules_1.Mousewheel, modules_1.Pagination, modules_1.Navigation],
            loop: false,
            direction: isMobile ? "vertical" : "horizontal", // スマホだったら縦にスライドが進む
            slidesPerView: 1,
            /*
            mousewheel: !isMobile,    // スマホでは無効化
            allowTouchMove: isMobile, // スマホは指で進む
            */
            mousewheel: !isMobile,
            allowTouchMove: false,
            speed: 900,
            pagination: isMobile ? false : {
                el: swiperPagination,
                type: "custom",
                renderCustom(swiper, current, total) {
                    // current を 2桁ゼロパディング
                    const padded = String(current).padStart(2, "0");
                    return `<span class="swiper-pagination-current">${padded}</span>`;
                }
            },
            navigation: isMobile ? false : {
                nextEl: swiperNextButton,
                prevEl: swiperPrevButton
            },
            on: {
                init() {
                    const activeSlide = this.slides[this.activeIndex];
                    gsap_1.gsap.set(activeSlide, { opacity: 1, duration: 1 });
                    // updateProgressNav(this.activeIndex);
                },
                slideChangeTransitionStart() {
                    const prev = this.slides[this.previousIndex];
                    gsap_1.gsap.to(prev, { opacity: 0, duration: 1 });
                    gsap_1.gsap.set(this.slides[this.activeIndex], { opacity: 0 });
                },
                slideChangeTransitionEnd() {
                    const active = this.slides[this.activeIndex];
                    gsap_1.gsap.to(active, { opacity: 1, duration: 1 });
                    // updateProgressNav(this.activeIndex);
                    // console.log(`this.activeIndex: ${this.activeIndex}`);
                    // 現在表示中のスライドが属する route を特定してログ出力
                    const activeSlideEl = this.slides[this.activeIndex];
                    const slideId = activeSlideEl?.id ?? '';
                    // console.log(`[ManufacturingSlider] 現在のスライド: #${slideId}`);
                    self.changeProgressImageAndMap(slideId, isProductMode);
                    /*
                    const pathname = window.location.pathname;
                    const isEn = pathname.startsWith('/en/');
                    // console.log(isEn);

                    const basePath = isEn
                        ? '/shared/img/content/about_en'
                        : '/shared/img/content/about';

                    console.log(slideId)
                    console.log(`isProductMode : ${isProductMode}`);

                    let addName = '';
                    if(isProductMode) {
                        addName = '-product';
                    }

                    const path = `${basePath}/progress`;
                    $('.bulletProgressImage').attr('src', `${path}/${slideId}${addName}.svg`);

                    const mapPath = `${basePath}/map`;
                    $('.bulletOpenRootMap').attr('src', `${mapPath}/${slideId}.svg`);
                    */
                    let body = '';
                    if (this.activeIndex === 0) {
                        body += `<div class="progress__list bulletProgressNumber">1</div>`;
                    }
                    else {
                        for (let i = 1; i <= this.activeIndex + 1; i++) {
                            if (this.activeIndex < i) {
                                body += `<div class="progress__list bulletProgressNumber"><i class="fa-solid fa-check"></i></div>`;
                            }
                            else {
                                body += `<div class="progress__list bulletProgressNumber">${i}</div>`;
                            }
                        }
                    }
                    $('.bulletProgressNumbers').html(body);
                },
            },
        });
        const stopSwiper = () => {
            isModalOpen = true;
            swiper.allowSlideNext = false;
            swiper.allowSlidePrev = false;
            if (!isMobile)
                swiper.mousewheel.disable();
        };
        const resumeSwiper = () => {
            isModalOpen = false;
            swiper.allowSlideNext = true;
            swiper.allowSlidePrev = true;
            if (!isMobile)
                swiper.mousewheel.enable();
        };
        //
        $('.trigSwitchRootMap').on('click', (e) => {
            const isOpen = $(e.currentTarget).attr('data-is-open');
            if (isOpen === 'false') {
                stopSwiper();
            }
            else {
                resumeSwiper();
            }
        });
        $('.trigCloseOverLay').on('click', (e) => {
            resumeSwiper();
        });
        // 「＞」クリックでも次スライドへ移動
        $(document).on('click', '.trigPrevSlide', () => swiper.slidePrev());
        $(document).on('click', '.trigNextSlide', () => swiper.slideNext());
        const branchHistory = [];
        let isAddingBranch = false;
        let isProductMode = false; // 製品情報モード判定用
        let isHashInitializing = false;
        // ルート名（ナビ表示用）
        const routeNames = {
            'a': ['パテンチング（2次焼線）', 'ブラスメッキ', '細物伸線'],
            'a-a': ['撚線', 'スチールコード'],
            'a-b': ['ホースワイヤ'],
            'a-c': ['ソーワイヤ'],
            'b': ['ブロンズメッキ', 'ビードワイヤ'],
            'c': ['ピアノ線'],
            'd': ['異形加工'],
            'd-a': ['バネ用線'],
            'd-b': ['ゼンマイ用線'],
            'd-c': ['オイルテンパー'],
            'd-c-a': ['表面研磨', 'ピストンリング用線'],
            'd-c-b': ['スナップリング用線'],
            'd-d': ['焼鈍'],
            'd-d-a': ['針地用線'],
            'd-d-b': ['繊維機器用線'],
            'e': ['細物伸線'],
            'e-a': ['精密微細'],
            'e-a-a': ['ドットピン'],
            'e-a-b': ['ワイヤープローブ'],
            'e-a-c': ['NIメッキ', 'プローブピン'],
            'e-b': ['極細伸線'],
            'e-b-a': ['研磨用線'],
            'e-b-b': ['極細異形', '極細バネ用線'],
            'e-b-c': ['医療用丸線'],
            'e-b-d': ['極細異形', '医療用平線・異形線'],
            'e-b-e': ['コイリング', '中空コイル'],
            'e-c': ['コーティング', 'PTFEコーティング線'],
            'e-d': ['極細撚線', 'トルクロープ'],
            'e-e': ['真直テーパー'],
            'e-e-a': ['真直線'],
            'e-e-b': ['ボビン巻き真直線'],
        };
        // どのルートがどのスライドIDから分岐するか（ここで指定）
        // 例：'a-a' の分岐ボタンは slide-a-03 の後に出る など
        const routeTriggerMap = {
            'a': 'slide-common-05',
            'b': 'slide-common-05',
            'c': 'slide-common-05',
            'd': 'slide-common-05',
            'e': 'slide-common-05',
            'a-a': 'slide-a-03',
            'a-b': 'slide-a-03',
            'a-c': 'slide-a-03',
            'd-a': 'slide-d-01',
            'd-b': 'slide-d-01',
            'd-c': 'slide-d-01',
            'd-d': 'slide-d-01',
            'd-c-a': 'slide-d-c-01',
            'd-c-b': 'slide-d-c-01',
            'd-d-a': 'slide-d-d-01',
            'd-d-b': 'slide-d-d-01',
            'e-a': 'slide-e-01',
            'e-b': 'slide-e-01',
            'e-c': 'slide-e-01',
            'e-d': 'slide-e-01',
            'e-e': 'slide-e-01',
            'e-a-a': 'slide-e-a-01',
            'e-a-b': 'slide-e-a-01',
            'e-a-c': 'slide-e-a-01',
            'e-b-a': 'slide-e-b-01',
            'e-b-b': 'slide-e-b-01',
            'e-b-c': 'slide-e-b-01',
            'e-b-d': 'slide-e-b-01',
            'e-b-e': 'slide-e-b-01',
            'e-e-a': 'slide-e-e-01',
            'e-e-b': 'slide-e-e-01',
        };
        // 進捗ナビ更新関数
        function updateProgressNav(activeIndex) {
            const boxes = document.querySelectorAll(".progress__box");
            boxes.forEach((box, i) => {
                const el = box;
                el.dataset.status = i < activeIndex ? "over" : i === activeIndex ? "now" : "yet";
            });
        }
        // ルートから分岐元スライドのインデックスを返す（見つからなければ undefined）
        function findTriggerIndexForRoute(route) {
            const triggerId = routeTriggerMap[route];
            if (!triggerId)
                return undefined;
            const el = document.getElementById(triggerId);
            if (!el)
                return undefined;
            const slides = Array.from(document.querySelectorAll('.swiper-slide'));
            const idx = slides.indexOf(el);
            return idx >= 0 ? idx : undefined;
        }
        // -------------------------------------------------
        // スライドとナビを追加する共通関数
        // route: 追加するルート（'a','b','a-a'...）
        // recordHistory: true -> 戻った時に削除対象として履歴に残す
        // startIndexOverride: 履歴に残す startIndex を明示（未指定時は swiper.activeIndex を使用）
        // 戻り削除を可能にするため、 recordHistory=true のとき branchHistory に push する
        // -------------------------------------------------
        async function addBranchSlides(route, recordHistory = true, startIndexOverride = null) {
            // 製品モードのときは isAddingBranch ロックをバイパス（製品モードで複数 route を順に追加する必要があるため）
            if (!isProductMode) {
                /*
                if (isAddingBranch) {
                    return;
                }
                */
                isAddingBranch = true;
            }
            try {
                // Ajaxで新しいスライド取得
                const res = await fetch(`ajax_get_slides.php?route=${encodeURIComponent(route)}`);
                const html = await res.text();
                const swiperWrapper = document.querySelector('.swiper-wrapper');
                //const navBoxes = document.querySelector('.progress__boxes');
                //if (!swiperWrapper || !navBoxes) return undefined;
                if (!swiperWrapper)
                    return undefined;
                // HTMLを末尾に挿入（既存の順序を維持）
                swiperWrapper.insertAdjacentHTML('beforeend', html);
                swiper.update();
                // 返されたHTMLから新しいスライドをカウントする
                const temp = document.createElement('div');
                temp.innerHTML = html;
                const newSlides = temp.querySelectorAll('.swiper-slide').length;
                // 進捗ナビ（.progress__boxes）に項目を追加
                const labels = routeNames[route] ?? Array.from({ length: newSlides }, (_, i) => `工程${i + 1}`);
                /*
                const currentNavCount = navBoxes.querySelectorAll('.progress__box').length;

                let navHtml = '';
                labels.forEach((label, i) => {
                    navHtml += `
                <li class="progress__box" data-status="yet">
                    <span class="progress__number">${currentNavCount + i + 1}</span>${label}
                </li>`;
                });
                navBoxes.insertAdjacentHTML('beforeend', navHtml);
                */
                // 履歴に保存する場合は startIndexOverride（渡されていればそれ）または現在の activeIndex を使う
                if (recordHistory && !isProductMode) {
                    const startIndex = (typeof startIndexOverride === 'number') ? startIndexOverride : swiper.activeIndex;
                    // 履歴に記録
                    branchHistory.push({
                        route,
                        startIndex,
                        slideCount: newSlides,
                        navCount: labels.length
                    });
                }
                swiper.update();
                return newSlides;
            }
            catch (err) {
                return undefined;
            }
            finally {
                if (!isProductMode) {
                    // 製品モードでないときだけロック解除
                    setTimeout(() => {
                        isAddingBranch = false;
                    }, 120);
                }
            }
        }
        // -------------------------------------------------
        // 分岐前にスライドが戻った時、追加したスライドとナビゲーションの削除
        // (製品モード時は無効化)
        // -------------------------------------------------
        swiper.on('slideChange', () => {
            if (isHashInitializing)
                return;
            if (isProductMode)
                return; // 製品モードでは削除しない
            requestAnimationFrame(() => {
                if (isAddingBranch)
                    return; // 追加中は削除しない
                const activeIndex = swiper.activeIndex;
                const wrapper = document.querySelector('.swiper-wrapper');
                //const navBoxes = document.querySelector('.progress__boxes');
                //if (!wrapper || !navBoxes) return;
                // 履歴の最後からチェックしていく（多段分岐に対応）
                while (branchHistory.length > 0) {
                    const last = branchHistory[branchHistory.length - 1];
                    // 現在位置が「その分岐が始まる前」に戻ったら
                    if (activeIndex <= last.startIndex) {
                        // スライド削除（末尾から last.slideCount 個を削除）
                        const slides = wrapper.querySelectorAll('.swiper-slide');
                        for (let i = slides.length - last.slideCount; i < slides.length; i++) {
                            slides[i]?.remove();
                        }
                        /*
                        // ナビ削除（末尾から last.navCount 個を削除）
                        const navs = Array.from(navBoxes.querySelectorAll('.progress__box'));
                        const startNavRemove = navs.length - last.navCount;
                        gsap.to(navs.slice(startNavRemove), {
                            opacity: 0,
                            duration: 0.3,
                            stagger: 0.05,
                            onComplete: () => {
                                for (let i = startNavRemove; i < navs.length; i++) {
                                    navs[i]?.remove();
                                }
                            }
                        });
                        */
                        swiper.update();
                        branchHistory.pop();
                    }
                    else {
                        break;
                    }
                }
            });
        });
        // -------------------------------------------------
        // 分岐ボタンクリック処理
        // -------------------------------------------------
        document.addEventListener('click', async (e) => {
            const btn = e.target.closest('.trigRouteBranchButton');
            if (!btn)
                return;
            const route = btn.dataset.route?.toLowerCase();
            if (!route)
                return;
            // クリック起点の startIndex は通常 activeIndex。 addBranchSlides 内で補正される。
            await addBranchSlides(route, true);
            // 追加後に一つ進める
            swiper.slideNext();
        });
        // -------------------------------------------------
        // ScrollTrigger + アニメーション初期化
        // -------------------------------------------------
        let skipScrollTriggerAnimation = () => { };
        // PC・TABでの処理
        if (!isMobile) {
            const fixedSection = document.querySelector('.fixedContents');
            const firstSection = document.querySelector('.bulletFirstSection');
            const swiperSection = target;
            const firstSectionInner = document.querySelector('.bulletFirstSectionInner');
            const swiperSectionInner = document.querySelector('.bulletKnowSliderInner');
            if (!fixedSection || !firstSection)
                return;
            // 「トクセン工業を知る」入口からの移動アニメーション
            const scrollAnim = gsap_1.gsap.timeline({ paused: true })
                .set(swiperSectionInner, { xPercent: 20 })
                .to(firstSection, { opacity: 0 }, "<")
                .to(firstSectionInner, { xPercent: -100 }, "<")
                .to(swiperSectionInner, { xPercent: 0 }, "<")
                .to(swiperSection, { opacity: 1 }, "<");
            // マウスホイールでスライドに移動
            document.addEventListener("wheel", function () {
                if (!isModalOpen) {
                    scrollAnim.play();
                    swiper.allowTouchMove = true;
                    swiper.mousewheel.enable();
                }
            });
            // 最初のスライドで、「製造工程から知る」か「製造工程に進む」ボタンを押してもスライドが始まるように
            const startButtons = document.querySelectorAll('.trigStartSlide');
            startButtons.forEach(button => {
                button.addEventListener("click", () => {
                    scrollAnim.play();
                    swiper.allowTouchMove = true;
                    swiper.mousewheel.enable();
                });
            });
            // 最初のスライドのスクロールトリガー演出スキップ
            skipScrollTriggerAnimation = () => {
                scrollAnim.progress(1, false);
                gsap_1.gsap.set(firstSection, { opacity: 0 });
                gsap_1.gsap.set(swiperSection, { opacity: 1 });
                gsap_1.gsap.set(swiperSectionInner, { xPercent: 0 });
                swiper.allowTouchMove = true;
                swiper.mousewheel.enable();
            };
            // ハッシュ初期表示などの既存処理のため export
            window.skipScrollTriggerAnimation = skipScrollTriggerAnimation;
        }
        else {
            // スマホの時の処理
            const firstSection = document.querySelector('.bulletFirstSection');
            const swiperSection = target;
            const firstSectionInner = document.querySelector('.bulletFirstSectionInner');
            const swiperSectionInner = document.querySelector('.bulletKnowSliderInner');
            // 最初のスライドからの移動アニメーション
            const scrollAnim = gsap_1.gsap.timeline({ paused: true })
                .set(swiperSectionInner, { yPercent: 20 })
                .to(firstSection, { opacity: 0 }, "<")
                .to(firstSectionInner, { yPercent: -100 }, "<")
                .to(swiperSectionInner, { yPercent: 0 }, "<")
                .to(swiperSection, { opacity: 1 }, "<");
            // 最初のスライドで、「製造工程から知る」か「製造工程に進む」ボタンを押してもスライドが始まるように
            const startButtons = document.querySelectorAll('.trigStartSlide');
            startButtons.forEach(button => {
                button.addEventListener("click", () => {
                    scrollAnim.play();
                    // swiper.allowTouchMove = true;
                });
            });
            // 最初のスライドをスキップ
            skipScrollTriggerAnimation = () => {
                scrollAnim.progress(1, false);
                gsap_1.gsap.set(firstSection, { opacity: 0 });
                gsap_1.gsap.set(swiperSection, { opacity: 1 });
                gsap_1.gsap.set(swiperSectionInner, { yPercent: 0 });
                // swiper.allowTouchMove = true;
            };
        }
        // -------------------------------------------------
        // ハッシュルート (/#slide-a-a-01 など)
        // -> ハッシュから route を取り出し、分岐元起点を (可能なら)特定して addBranchSlides に渡す
        // -------------------------------------------------
        function parseRouteFromHash(hash) {
            if (!hash)
                return null;
            const h = hash.replace(/^#/, '');
            const m = h.match(/^slide-([a-z]+(?:-[a-z]+)*)(?:-\d+)?$/i);
            return m ? m[1].toLowerCase() : null;
        }
        async function handleInitialHashIfAny() {
            const raw = window.location.hash;
            if (!raw)
                return;
            const route = parseRouteFromHash(raw);
            // 共通工程のスライドの場合
            if (route === "common") {
                // スクロール演出をスキップ
                skipScrollTriggerAnimation();
                // swiper を更新して
                swiper.update();
                // 目的の common スライドへ移動
                const hash = raw.replace('#', '');
                const targetEl = document.getElementById(hash);
                if (targetEl) {
                    const slides = Array.from(document.querySelectorAll('.swiper-slide'));
                    const index = slides.indexOf(targetEl);
                    if (index !== -1)
                        swiper.slideTo(index, 0);
                }
                /*
                if (window.name !== 'reloaded') {
                    window.name = 'reloaded'; // 1回目: 'reloaded'を設定
                    window.location.reload(); // ページをリロード
                }

                setTimeout( () => {
                    window.name = '';
                }, 500);
                */
                return; // ★ ここで処理を終わりにする
            }
            else {
                // 入口スキップ
                skipScrollTriggerAnimation();
                // Swiper位置を初期化
                swiper.slideTo(0, 0);
                await new Promise((res) => setTimeout(res, 0));
                // ① route を階層に分割する
                const parts = route.split("-");
                const hierarchy = [];
                for (let i = 0; i < parts.length; i++) {
                    hierarchy.push(parts.slice(0, i + 1).join("-"));
                }
                // ② 階層順に addBranchSlides を実行
                for (const r of hierarchy) {
                    const triggerIndex = findTriggerIndexForRoute(r);
                    await addBranchSlides(r, true, (typeof triggerIndex === "number" ? triggerIndex : null));
                    swiper.update();
                    await new Promise((res) => setTimeout(res, 0)); // DOM反映待ち
                }
                // ③ 最後に該当スライドへ移動
                requestAnimationFrame(() => {
                    const hash = raw.replace("#", "");
                    const targetEl = document.getElementById(hash) ||
                        document.querySelector(`.swiper-slide[id^="slide-${route}"]`);
                    if (targetEl) {
                        const slides = Array.from(document.querySelectorAll('.swiper-slide'));
                        const index = slides.indexOf(targetEl);
                        if (index !== -1) {
                            swiper.slideTo(index, 20);
                            updateProgressNav(index);
                        }
                    }
                });
            }
        }
        handleInitialHashIfAny();
        // -------------------------------------------------
        // 製品情報モード（?product=xxx）
        // ・「スライド戻りで削除しない」仕様のため recordHistory = false
        // ・分岐ボタンを「>」に置換する
        // -------------------------------------------------
        async function handleProductMode() {
            const params = new URLSearchParams(location.search);
            const product = params.get('product');
            if (!product)
                return;
            isProductMode = true;
            // 製品モードのときは、製造工程MAP・プログレスを変更する
            const firstSlide = 'slide-common-01';
            self.changeProgressImageAndMap(firstSlide, isProductMode);
            skipScrollTriggerAnimation();
            // 製品ができあがるまでに必要なルートをここに記載
            const productRoutes = {
                steelCord: ['a', 'a-a'], // スチールコード
                hoseWire: ['a', 'a-b'], // ホースワイヤ
                sawWire: ['a', 'a-c'], // ソーワイヤ
                beadWire: ['b'], // ビードワイヤ
                pianoWire: ['c'], // ピアノ線
                springWire: ['d', 'd-a'], // バネ用線
                mainSpringWire: ['d', 'd-b'], // ゼンマイ用線
                pistonRingWire: ['d', 'd-c', 'd-c-a'], // ピストンリング用線
                snapRingWire: ['d', 'd-c', 'd-c-b'], // スナップリング用線
                needleLine: ['d', 'd-d', 'd-d-a'], // 針地用線
                textileWire: ['d', 'd-d', 'd-d-b'], // 繊維機器用線
                dotPin: ['e', 'e-a', 'e-a-a'], // ドットピン
                wireProbe: ['e', 'e-a', 'e-a-b'], // ワイヤープローブ
                probePin: ['e', 'e-a', 'e-a-c'], // プローブピン
                polishingWire: ['e', 'e-b', 'e-b-a'], // 研磨用線
                ultraFineSpringWire: ['e', 'e-b', 'e-b-b'], // 極細バネ用線
                medicalRoundWire: ['e', 'e-b', 'e-b-c'], // 医療用丸線
                medicalFlatWire: ['e', 'e-b', 'e-b-d', 'e-b-f'], // 医療用平線・異形線
                hollowCoil: ['e', 'e-b', 'e-b-e'], // 中空コイル
                ptfe: ['e', 'e-c'], // PTFEコーティング線
                torqueLoop: ['e', 'e-d'], // トルクロープ
                straightLine: ['e', 'e-e', 'e-e-a'], // 真直線
                bobbin: ['e', 'e-e', 'e-e-b'], // ボビン巻き真直線
            };
            const routes = productRoutes[product];
            if (!routes) {
                return;
            }
            // 各 route を順に追加（製品情報モードなので履歴に残さない）
            for (const route of routes) {
                const triggerIndex = findTriggerIndexForRoute(route) ?? null;
                await addBranchSlides(route, false, triggerIndex);
            }
            // 分岐ボタンを「>」に置換（元の仕様を維持）
            const swiperWrapper = document.querySelector('.swiper-wrapper');
            if (swiperWrapper) {
                const isSpSize = window.matchMedia('(max-width: 768px)').matches;
                swiperWrapper.querySelectorAll('.branchButtonsNotShow').forEach(btn => {
                    const slide = btn.closest('.swiper-slide');
                    btn.remove();
                    const arrow = document.createElement('div');
                    arrow.classList.add('flow__next-arrow', 'trigNextSlide');
                    arrow.innerHTML = '&gt;';
                    // スマホサイズの時は、「>」ボタンの挿入位置を変更（デザインのため）
                    if (isSpSize) {
                        const boxes = slide.querySelector('.paramNextButtonSp');
                        if (boxes) {
                            boxes.appendChild(arrow); // .paramNextButtonSpの中の最後に入れる
                        }
                        else {
                            slide.appendChild(arrow); // フォールバック
                        }
                    }
                    else {
                        slide.appendChild(arrow);
                    }
                });
            }
            // 最後に共通の最初のスライドへ移動
            requestAnimationFrame(() => {
                swiper.update();
                const firstCommon = document.getElementById('slide-common-01');
                if (firstCommon) {
                    const slides = Array.from(document.querySelectorAll('.swiper-slide'));
                    const index = slides.indexOf(firstCommon);
                    if (index !== -1) {
                        swiper.slideTo(index, 0);
                        updateProgressNav(index);
                    }
                }
            });
        }
        handleProductMode();
    }
    changeProgressImageAndMap(slideId, isProductMode = false) {
        const pathname = window.location.pathname;
        const isEn = pathname.startsWith('/en/');
        const basePath = isEn
            ? '/shared/img/content/about_en'
            : '/shared/img/content/about';
        console.log(slideId);
        console.log(`isProductMode : ${isProductMode}`);
        let addFolder = '';
        if (isProductMode) {
            // /?product=beadWireなどのときは 値を取得していれる
            const params = new URLSearchParams(location.search);
            const name = params.get('product');
            // すべて小文字にしてスペースを削除（例: "Bead Wire" -> "beadwire"）
            addFolder = '/' + name.toLowerCase().replace(/\s+/g, '');
        }
        const path = `${basePath}/progress${addFolder}`;
        $('.bulletProgressImage').attr('src', `${path}/${slideId}.svg`);
        const mapPath = `${basePath}/map`;
        $('.bulletOpenRootMap').attr('src', `${mapPath}/${slideId}.svg`);
    }
}
exports.ManufacturingSlider = ManufacturingSlider;
exports.default = ManufacturingSlider;
